export const completionVi = {
  "serverPaging": {
    "label": "Phân trang",
    "total": "Tổng {total} · Trang {page}/{pages}",
    "previous": "Trang trước",
    "next": "Trang sau"
  },
  "dashboardPeriod": {
    "from": "Từ ngày",
    "to": "Đến ngày",
    "registration": "Tổng hợp dự án",
    "delivery": "Tiến độ dự án",
    "resources": "Nguồn lực",
    "generated": "Cập nhật lúc {at}",
    "loadingRows": "Đang tải {loaded}/{total} dự án"
  },
  "auditQuery": {
    "type": "Loại đối tượng"
  },
  "workflowExtensions": {
    "sla": "Hạn xử lý (giờ làm việc)",
    "escalation": "Vai trò nhận chuyển cấp",
    "delegations": "Ủy quyền của tôi",
    "delegateTo": "Ủy quyền cho",
    "targetType": "Loại hồ sơ (bỏ trống để áp dụng tất cả)",
    "revoke": "Thu hồi",
    "revokeConfirm": "Thu hồi ủy quyền này?",
    "due": "Hạn xử lý",
    "overdue": "Quá hạn",
    "onBehalf": "Thực hiện thay cho"
  },
  "reportExtensions": {
    "pending": "Báo cáo chờ duyệt",
    "category": "Phân loại",
    "deleteLesson": "Xóa bài học này?",
    "distributions": "Lịch sử gửi",
    "noApprovedReport": "Bỏ qua: chưa có báo cáo được duyệt",
    "dispatched": "Đã phát hành"
  },
  "executionHub": {
    "myWork": "Việc của tôi",
    "activeProjects": "Dự án đang thực hiện",
    "teamHub": "Theo tổ",
    "today": "Hôm nay",
    "due": "Đến hạn",
    "overdue": "Quá hạn",
    "notStarted": "Chưa bắt đầu",
    "pending": "{count} phần chờ duyệt",
    "pendingPart": "Phần công chờ duyệt",
    "hours": "giờ",
    "row": {
      "hours": "Giờ hôm nay",
      "description": "Mô tả",
      "descriptionHint": "Để trống: dùng mã + tên việc",
      "descriptionToggle": "Thêm mô tả giờ (tùy chọn)",
      "attach": "Đính kèm tệp cho việc này",
      "attaching": "Đang tải tệp…",
      "attached": "Đã đính kèm {count} tệp",
      "dueDate": "Hạn {date}",
      "saving": "Đang lưu…",
      "savedBoth": "% đã lưu · giờ đã ghi",
      "savedProgress": "% đã lưu",
      "savedHours": "giờ đã ghi",
      "hoursFailedAfterProgress": "% đã lưu · giờ chưa ghi",
      "hoursFailed": "giờ chưa ghi",
      "notSaved": "chưa lưu",
      "retryHours": "Ghi giờ lại",
      "lockSheet": "Bảng công ngày này đã gửi hoặc đã duyệt; bấm «Rút lại» trên thanh ngày nếu cần sửa giờ.",
      "lockPart": "Phần công của dự án này đang chờ hoặc đã duyệt; nhờ trưởng dự án mở lại nếu cần sửa giờ.",
      "sheetUnavailable": "Không đọc được bảng công ngày này nên chưa ghi giờ được.",
      "hoursInvalid": "Giờ từ 0,25 đến 16, theo bước 0,25.",
      "afterProjectEnd": "Dự án đã kết thúc ngày {date}, không ghi giờ được.",
      "done": "Xong",
      "blockedHint": "Việc đang tạm dừng: bấm «Bỏ chặn» trước khi báo tiến độ.",
      "lateReason": "Lý do trễ",
      "lateReasonHint": "Việc đã quá hạn kế hoạch, ghi ngắn vì sao"
    },
    "day": {
      "saveAll": "Lưu cả ngày ({count})",
      "savedAll": "Đã lưu {count} việc.",
      "saveAllFailed": "Đã lưu {ok} việc, {failed} việc chưa lưu, xem dòng báo lỗi.",
      "sheetSummary": "Công hôm nay: {hours} giờ",
      "noSheet": "Chưa có giờ nào hôm nay",
      "submit": "Gửi công hôm nay",
      "resubmit": "Gửi lại công hôm nay",
      "withdraw": "Rút lại",
      "submitted": "Đã gửi công hôm nay, chờ trưởng dự án duyệt.",
      "withdrawn": "Đã rút bảng công về nháp."
    },
    "team": {
      "approveDay": "Duyệt cả ngày ({count})",
      "approveDayDone": "Đã duyệt {ok}/{total} phần công.",
      "viewMonitoring": "Giám sát",
      "viewTeam": "Theo tổ"
    },
    "week": {
      "label": "Tuần",
      "status": {
        "Missing": "Thiếu công",
        "Draft": "Nháp",
        "Submitted": "Đã gửi",
        "Approved": "Đã duyệt",
        "Rejected": "Từ chối",
        "NonWorkday": "Ngày nghỉ"
      }
    },
    "other": {
      "title": "Giờ khác hôm nay",
      "hint": "Họp, đào tạo, việc khác không thuộc tiến độ một việc; nghỉ phép và tăng ca lấy từ đơn đã duyệt, không ghi ở đây.",
      "type": "Loại",
      "types": {
        "Meeting": "Họp",
        "Training": "Đào tạo",
        "Other": "Khác"
      },
      "attachTo": "Gắn vào việc",
      "save": "Lưu giờ khác",
      "saved": "Đã lưu giờ khác hôm nay.",
      "remove": "Bỏ",
      "locked": "Bảng công đã gửi hoặc đã duyệt; bấm «Rút lại» trước khi sửa.",
      "noTask": "Chưa có việc nào trong ngày để gắn giờ khác (mỗi dòng công phải thuộc một việc của dự án).",
      "existing": "{type} · {hours} giờ"
    },
    "obligation": {
      "warning": "Việc có tiến độ nhưng chưa ghi giờ hôm nay",
      "reason": "Lý do",
      "reasonHint": "Lý do chưa ghi giờ (tối đa 1.000 ký tự)",
      "save": "Lưu lý do",
      "saved": "Đã lưu lý do.",
      "explained": "Đã giải trình",
      "others": "Việc khác chưa ghi giờ"
    },
    "history": {
      "button": "Lịch sử",
      "title": "Lịch sử bảng công ngày {date}",
      "version": "v{version}",
      "current": "Bản hiện tại",
      "task": "Việc",
      "hours": "Giờ"
    },
    "reminder": {
      "toggle": "Nhắc gửi công",
      "hint": "Nhắc lúc {time} ({zone})",
      "saved": "Đã lưu nhắc gửi công."
    },
    "attendance": {
      "clock": "Máy chấm công {in}–{out}",
      "leave": "Nghỉ phép {hours} giờ",
      "overtime": "Tăng ca {hours} giờ"
    }
  }
}
export const completionEn = {
  "serverPaging": {
    "label": "Pagination",
    "total": "Total {total} · Page {page}/{pages}",
    "previous": "Previous page",
    "next": "Next page"
  },
  "dashboardPeriod": {
    "from": "From",
    "to": "To",
    "registration": "Project summary",
    "delivery": "Project progress",
    "resources": "Resources",
    "generated": "Updated at {at}",
    "loadingRows": "Loading {loaded}/{total} projects"
  },
  "auditQuery": {
    "type": "Target type"
  },
  "workflowExtensions": {
    "sla": "Due in working hours",
    "escalation": "Escalation roles",
    "delegations": "My delegations",
    "delegateTo": "Delegate to",
    "targetType": "Target type (blank for all)",
    "revoke": "Revoke",
    "revokeConfirm": "Revoke this delegation?",
    "due": "Due",
    "overdue": "Overdue",
    "onBehalf": "Acted on behalf of"
  },
  "reportExtensions": {
    "pending": "Reports awaiting review",
    "category": "Category",
    "deleteLesson": "Delete this lesson?",
    "distributions": "Delivery history",
    "noApprovedReport": "Skipped: no approved report",
    "dispatched": "Dispatched"
  },
  "executionHub": {
    "myWork": "My work",
    "activeProjects": "Active projects",
    "teamHub": "By team",
    "today": "Today",
    "due": "Due",
    "overdue": "Overdue",
    "notStarted": "Not started",
    "pending": "{count} parts awaiting review",
    "pendingPart": "Timesheet part awaiting review",
    "hours": "hours",
    "row": {
      "hours": "Hours today",
      "description": "Description",
      "descriptionHint": "Blank: task code + name",
      "descriptionToggle": "Add an hours note (optional)",
      "attach": "Attach a file to this task",
      "attaching": "Uploading file…",
      "attached": "{count} file(s) attached",
      "dueDate": "Due {date}",
      "saving": "Saving…",
      "savedBoth": "% saved · hours logged",
      "savedProgress": "% saved",
      "savedHours": "hours logged",
      "hoursFailedAfterProgress": "% saved · hours not logged",
      "hoursFailed": "hours not logged",
      "notSaved": "not saved",
      "retryHours": "Log hours again",
      "lockSheet": "This day's timesheet is submitted or approved; click «Withdraw» on the day bar to edit hours.",
      "lockPart": "This project's timesheet part is pending or approved; ask the project leader to reopen it.",
      "sheetUnavailable": "The timesheet of this day could not be read, so hours cannot be logged yet.",
      "hoursInvalid": "Hours from 0.25 to 16, in 0.25 steps.",
      "afterProjectEnd": "The project ended on {date}; hours cannot be logged.",
      "done": "Done",
      "blockedHint": "The task is blocked: click «Unblock» before reporting progress.",
      "lateReason": "Late reason",
      "lateReasonHint": "Past the planned end, say briefly why"
    },
    "day": {
      "saveAll": "Save the day ({count})",
      "savedAll": "Saved {count} tasks.",
      "saveAllFailed": "Saved {ok} tasks, {failed} not saved, see the row messages.",
      "sheetSummary": "Today's hours: {hours}",
      "noSheet": "No hours today yet",
      "submit": "Submit today's hours",
      "resubmit": "Resubmit today's hours",
      "withdraw": "Withdraw",
      "submitted": "Today's hours submitted, awaiting the leader.",
      "withdrawn": "Timesheet withdrawn to draft."
    },
    "team": {
      "approveDay": "Approve the day ({count})",
      "approveDayDone": "Approved {ok}/{total} timesheet parts.",
      "viewMonitoring": "Monitoring",
      "viewTeam": "By team"
    },
    "week": {
      "label": "Week",
      "status": {
        "Missing": "Missing",
        "Draft": "Draft",
        "Submitted": "Submitted",
        "Approved": "Approved",
        "Rejected": "Rejected",
        "NonWorkday": "Day off"
      }
    },
    "other": {
      "title": "Other hours today",
      "hint": "Meetings, training and other work outside a task's progress; leave and overtime come from approved requests and are not logged here.",
      "type": "Type",
      "types": {
        "Meeting": "Meeting",
        "Training": "Training",
        "Other": "Other"
      },
      "attachTo": "Attach to task",
      "save": "Save other hours",
      "saved": "Other hours saved for today.",
      "remove": "Remove",
      "locked": "The timesheet is submitted or approved; click «Withdraw» before editing.",
      "noTask": "No task today to attach other hours to (every timesheet row must belong to a project task).",
      "existing": "{type} · {hours} h"
    },
    "obligation": {
      "warning": "Task has progress but no hours logged today",
      "reason": "Reason",
      "reasonHint": "Why no hours were logged (max 1,000 characters)",
      "save": "Save reason",
      "saved": "Reason saved.",
      "explained": "Explained",
      "others": "Other tasks without hours"
    },
    "history": {
      "button": "History",
      "title": "Timesheet history for {date}",
      "version": "v{version}",
      "current": "Current version",
      "task": "Task",
      "hours": "Hours"
    },
    "reminder": {
      "toggle": "Remind me to submit",
      "hint": "Reminder at {time} ({zone})",
      "saved": "Reminder preference saved."
    },
    "attendance": {
      "clock": "Time clock {in}–{out}",
      "leave": "Leave {hours} h",
      "overtime": "Overtime {hours} h"
    }
  }
}
